import { render, staticRenderFns } from "./FirstTemplate.vue?vue&type=template&id=f388e8e4&scoped=true&"
import script from "./FirstTemplate.vue?vue&type=script&lang=js&"
export * from "./FirstTemplate.vue?vue&type=script&lang=js&"
import style0 from "./FirstTemplate.vue?vue&type=style&index=0&id=f388e8e4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f388e8e4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VApp,VCol,VContainer,VRow})
